import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar } from 'reactstrap';
import renderField from '../../../shared/components/form/RenderField';
import Select from '../../../shared/components/form/Select';
import SmartAvatar from '../../../shared/components/form/SmartAvatar';
import AvailableToSelector from './AvailableToSelector';
import GraphQL from '../../../GraphQL';
import {
  relationObjectListByParams,
  availableEmployeeComChannel,
} from '../../../shared/queries/CommunicationChannel';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import validate from './Validate';
import { AVAILABLE_TO } from '../../../shared/utils/constants';

const CommunicationChannelForm = (props) => {
  const {
    t,
    backHandler,
    dto,
    initialize,
    showLoading,
    hideLoading,
    change,
    handleSubmit,
  } = props;
  const [availableVisibleTo, setAvailableVisibleTo] = useState();
  const [members, setMembers] = useState();
  const [fileUrl, setFileUrl] = useState();

  function loadAvailableVisibleTo() {
    showLoading();
    const query = relationObjectListByParams();
    GraphQL(query, {})
      .then((res) => {
        if (res.relationObjectListByParams) {
          res.relationObjectListByParams = res.relationObjectListByParams.map(
            (item) => ({
              ...item,
              value: item.id,
              label: item.description,
            })
          );
          setAvailableVisibleTo(res.relationObjectListByParams);
          hideLoading();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  }

  function loadMembers() {
    showLoading();
    const query = availableEmployeeComChannel();
    GraphQL(query, {})
      .then((res) => {
        if (res.availableEmployeeComChannel) {
          res.availableEmployeeComChannel = res.availableEmployeeComChannel.map(
            (item) => ({
              ...item,
              value: item.id,
              label: item.name,
            })
          );
          setMembers(res.availableEmployeeComChannel);
          hideLoading();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.find-record-error')
        );
      });
  }

  const ChannelPhotoChangeHandler = (file) => {
    setFileUrl(file.fileUrl);
    change('fileUrl', file.fileUrl);
    change('co90File', file.fileId);
  };

  useEffect(() => {
    initialize(dto);
    loadAvailableVisibleTo();
    loadMembers();
    if (dto.fileUrl && dto.co90File) {
      setFileUrl(dto.fileUrl);
      change('fileUrl', dto.fileUrl);
    }
    if (!dto.availableTo) {
      dto.availableTo = AVAILABLE_TO.ONLY_RESPONSIBLES;
    }

    if (dto.id === 0) {
      dto.visibleTo = null;
      dto.employees = null;
    }
  }, [dto]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <div className="form__form-group--centered">
            <SmartAvatar
              name="co90File"
              avatarSrc={fileUrl}
              avatarChangeHandler={ChannelPhotoChangeHandler}
              id={dto.id}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.name')}</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('general.name')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_communication_channel.availableTo')}
          </span>
          <div className="form__form-group-field">
            <Field name="availableTo" component={AvailableToSelector} t={t} />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_communication_channel.visibleTo')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="visibleTo"
              type="text"
              isMulti
              component={Select}
              placeholder={t('mnt_communication_channel.visibleTo')}
              options={availableVisibleTo}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_communication_channel.members')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="employees"
              type="text"
              isMulti
              component={Select}
              placeholder={t('mnt_communication_channel.members')}
              options={members}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.description')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="description"
              type="text"
              component="textarea"
              maxLength="2000"
              placeholder={t('general.description')}
            />
          </div>
        </div>
        <ButtonToolbar>
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

CommunicationChannelForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'CommunicationChannelForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(CommunicationChannelForm));
